<template>
  <div class="row row-equal">
    <div class="flex md12">
      <va-card v-if="!computeCampagne && !displayError">
        <div class="row align--center">
          <div class="flex xs6 md3">
            <va-input
              :value="nomRe"
              :placeholder="$t('poissonnierTable.searchByName')"
              removable
              @input="searchNom"
            >
              <va-icon name="fa fa-search" slot="prepend" />
            </va-input>
          </div>

          <div class="flex xs6 md3">
            <va-input
              :value="cpRe"
              :placeholder="$t('poissonnierTable.searchByPostcode')"
              removable
              @input="searchPostcode"
            >
              <va-icon name="fa fa-search" slot="prepend" />
            </va-input>
          </div>
          <div class="flex md2">
            <va-button-toggle
              outline
              class="toggle-activite"
              v-model="showinactive"
              :options="options"
            />
          </div>
          <div class="flex xs12 md2">
            <div class="row row-inside">
              <h5
                class="selection-nb-title"
                :style="{ color: this.$themes.primary }"
              >
                Sélect. : {{ filteredData.length }}
              </h5>
              <va-popover message="Rafraichir" placement="top">
                <va-button
                  class="selection-refresh"
                  flat
                  color="primary"
                  icon="fa fa-refresh"
                  @click="loadList()"
                />
              </va-popover>
            </div>
          </div>

          <div class="flex md1 offset--md1">
            <va-input
              class="centered"
              :value="perPage"
              :label="$t('tables.perPage')"
              @input="changePageNumber"
            ></va-input>
          </div>
        </div>
        <div v-if="loadingStatuts" class="d-flex justify--center spinner">
          <div>
            <va-progress-circle indeterminate />
          </div>
        </div>

        <va-data-table
          v-if="showinactive === 'single'"
          ref="dataTableSyndicat"
          class="va-table--hoverable va-table--stripped no-overflow"
          :fields="fields"
          :data="filteredData"
          :no-data-label="$t('poissonnierTable.empty')"
          :per-page="parseInt(perPage)"
          @row-clicked="showEntreprise"
          clickable
        >
          <template slot="level" slot-scope="props">
            <div class="row row-inside">
              <div class="flex md12">
                <va-badge
                  v-if="props.rowData.niveau === 1"
                  color="success"
                  class="fullwidth"
                  >Niveau 1</va-badge
                >
                <va-badge
                  v-if="props.rowData.niveau === 2"
                  color="warning"
                  class="fullwidth"
                  >Niveau 2</va-badge
                >
                <va-badge
                  v-if="props.rowData.niveau === 3"
                  color="danger"
                  class="fullwidth"
                  >Niveau 3</va-badge
                >
              </div>
            </div>
          </template>

          <template slot="envoiType" slot-scope="props">
            <div class="row row-inside">
              <div class="flex md12">
                <va-badge
                  v-if="props.rowData.idcourrier"
                  color="info"
                  class="fullwidth"
                  >Courrier</va-badge
                >
                <va-badge
                  v-if="props.rowData.idemail"
                  :color="props.rowData.issend ? 'info' : 'danger'"
                  class="fullwidth"
                  >Courriel</va-badge
                >
              </div>
            </div>
          </template>

          <template slot="actions" slot-scope="props">
            <div class="row row-inside">
              <div class="flex md12">
                <va-button
                  outline
                  small
                  color="info"
                  v-if="props.rowData.idcourrier"
                  v-on:click.middle="
                    openCourrier(props.rowData.idcourrier, props.rowData.nom)
                  "
                  @click="
                    downloadCourrier(
                      props.rowData.idcourrier,
                      props.rowData.nom
                    )
                  "
                  >Courrier</va-button
                >
                <va-button
                  outline
                  small
                  color="info"
                  v-if="props.rowData.idemail"
                  v-on:click.middle="
                    openEmailPdf(props.rowData.idemail, props.rowData.nom)
                  "
                  @click="
                    downloadEmailPdf(props.rowData.idemail, props.rowData.nom)
                  "
                  >Courriel</va-button
                >
              </div>
            </div>
          </template>

          <template slot="selection" slot-scope="props">
            <div
              class="row row-inside"
              v-if="!selectLimit || props.rowData.selected"
            >
              <div class="flex md3" @click="preventDefaultAction()">
                <va-checkbox
                  v-if="props.rowData.idcourrier"
                  v-model="props.rowData.selected"
                  label="courrier"
                />
              </div>
            </div>
          </template>
        </va-data-table>
        <div
          class="flex xs12 md1 offset--md11"
          v-if="showinactive === 'single'"
        >
          <div class="row row-inside">
            <va-button
              large
              class="start-button"
              @click="validateAndStart"
              :disabled="!selected.length"
              >Valider</va-button
            >
          </div>
        </div>
        <va-data-table
          v-if="showinactive === 'group'"
          class="va-table--hoverable va-table--stripped no-overflow"
          :fields="fieldsPdfs"
          :data="listPdfs"
          :no-data-label="$t('poissonnierTable.empty')"
          :per-page="parseInt(perPage)"
        >
          <template slot="download" slot-scope="props">
            <div class="row row-inside">
              <div class="flex md12">
                <va-button
                  outline
                  small
                  color="info"
                  v-on:click.middle="openAgregPdf(props.rowData.idcampagnepdf)"
                  @click="downloadAgregPdf(props.rowData.idcampagnepdf)"
                  >Ouvrir le document</va-button
                >
                <va-button
                  outline
                  small
                  color="info"
                  v-if="props.rowData.idemail"
                  disabled
                  >Courriel</va-button
                >
              </div>
            </div>
          </template>
        </va-data-table>
      </va-card>
      <va-card v-if="computeCampagne && !displayError">
        <h4>Génération du document en cours, veuillez patienter</h4>
        <br />
        <va-progress-bar :value="valueProgress" />
      </va-card>
      <va-card v-if="displayError">
        <br />
        <br />
        <h4>
          Une erreur semble avoir survenue lors de la génération des courriers.
          Veuillez rafraichir la page. Regardez dans 10min si votre document se
          trouve dans les archives.
        </h4>
        <br />
        <br />
      </va-card>
    </div>

    <dashboard-fiche-entreprise
      v-model="showFicheEntreprise"
      :tableentreprise="tableentreprise"
      @update="updateEntreprise"
    />

    <va-modal
      class="modal"
      title="Validation du plan d'adhésion"
      v-model="showConfirm"
      cancelClass="clearStats"
      okText="Valider"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="launchCampaign()"
      v-on:cancel="clearStats"
    >
      Souhaitez vous valider l'envoi de
      <b>{{ ncourriel }}</b>
      courriels et la réimpression de
      <b>{{ ncourrier }}</b> courriers?
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DashboardFicheEntreprise from "../dashboard/DashboardFicheEntreprise";

import { cloneDeep, debounce, findIndex, deburr } from "lodash";

export default {
  name: "DashboardTableArchive",
  components: {
    DashboardFicheEntreprise,
  },
  props: ["syndicat"],
  data() {
    return {
      isaction: false,
      tableentreprise: "",
      showFicheEntreprise: false,
      computeCampagne: false,
      displayError: false,
      valueProgress: 0,
      listEnvois: [],
      listPdfs: [],
      nomRe: null,
      cpRe: null,
      perPage: "6",
      showConfirm: false,
      ncourriel: 0,
      ncourrier: 0,
      showWorkOnProgress: false,
      options: [
        { label: "Individuels", value: "single" },
        { label: "Groupés", value: "group" },
      ],
      showinactive: "single",
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    updateEntreprise() {
      //TODO update entreprise in table
    },
    preventDefaultAction() {
      this.isaction = true;
    },
    showEntreprise(entreprise) {
      if (!this.isaction) {
        console.log(entreprise);
        this.showFicheEntreprise = true;
        this.tableentreprise = entreprise;
      }
      this.isaction = false;
    },
    async loadList() {
      this.loadingStatuts = true;
      let response = await axios.get("/api/campagnes/archives", {
        params: { syndicat: this.syndicat },
      });
      response.data = response.data.filter((element) => {
        return element.idenvoi ? true : false;
      });
      response.data.forEach((element) => {
        element.niveauTxt = element.niveau.toString();
        element.envoiType = element.idcourrier ? "Courrier" : "";
        element.envoiType += element.idemail ? "\r\nCourriel" : "";
        element.envoiType += element.reedition
          ? "\r\n(Réédition " + element.reedition + ")"
          : "";
        element.selected = false;
        element.sendemail = false;
        element.sendcourrier = true;
      });
      this.listEnvois = response.data;
      // sort list by send date
      this.listEnvois.sort(function compare(a, b) {
        var dateA = new Date(a.dateenvoi);
        var dateB = new Date(b.dateenvoi);
        return dateB - dateA;
      });

      this.loadingStatuts = false;
      let response2 = await axios.get("/api/campagnes/pdfs", {
        params: { syndicat: this.syndicat },
      });
      response2.data.forEach((element) => {
        element.date = moment(element.datecreation).format("DD-MM-YYYY");
        element.heure = moment(element.datecreation).format("HH:mm:ss");
      });
      this.listPdfs = response2.data;
    },
    validateAndStart() {
      // calculate stats:
      this.selected.forEach((element) => {
        if (element.sendcourrier) this.ncourrier += 1;
        if (element.sendemail) {
          element.sendemail = false;
        }
      });
      this.showConfirm = true;
    },
    async launchCampaign() {
      try {
        this.computeCampagne = true;
        let params = {
          selected: this.selected,
          syndicat: this.syndicat,
        };
        let pres = axios.post("/api/campagnes/reedit", params);
        this.clearStats();
        let res = await pres;
        // open new tab with results
        window.open(res.data, "_blank");
        this.loadList();
        this.computeCampagne = false;
      } catch (err) {
        console.log(err);
        this.displayError = true;
        this.loadList();
        this.clearStats();
      }
    },
    // TODO temp to get access to the bulletin for sent mail
    async getEmailPdf(idemail) {
      let response = await axios.get("/api/campagnes/email", {
        params: { idemail: idemail },
      });
      return response.data;
    },
    async openEmailPdf(idemail, name) {
      let url = await this.getEmailPdf(idemail);
      window.open(url, "_blank");
    },
    async downloadEmailPdf(idemail, name) {
      let url = await this.getEmailPdf(idemail);
      this.downloadItem(url, name);
    },
    async getCourrier(idcourrier) {
      let response = await axios.get("/api/campagnes/courrier", {
        params: { idcourrier: idcourrier },
      });
      return response.data;
    },
    async openCourrier(idcourrier, name) {
      let url = await this.getCourrier(idcourrier);
      window.open(url, "_blank");
    },
    async downloadCourrier(idcourrier, name) {
      let url = await this.getCourrier(idcourrier);
      this.downloadItem(url, name);
    },
    async getAgregPdf(idpdf) {
      let response = await axios.get("/api/campagnes/agregpdf", {
        params: { idcampagnepdf: idpdf },
      });
      let url = response.data;
      return url;
    },
    async openAgregPdf(idpdf) {
      let url = await this.getAgregPdf(idpdf);
      window.open(url, "_blank");
    },
    async downloadAgregPdf(idpdf) {
      let url = await this.getAgregPdf(idpdf);
      this.downloadItem(url, "Bulletins " + this.syndicat + " (réédition)");
    },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },

    clearStats() {
      this.ncourriel = 0;
      this.ncourrier = 0;
    },
    searchNom: debounce(function (nomRe) {
      this.nomRe = nomRe;
    }, 400),
    searchPostcode: debounce(function (cpRe) {
      this.cpRe = cpRe;
    }, 400),
    changePageNumber: debounce(function (perPage) {
      var n = Math.floor(Number(perPage));
      if (n !== Infinity && String(n) === perPage && n >= 0) {
        this.perPage = perPage;
      } else {
        this.perPage = "6";
      }
    }, 400),
  },
  computed: {
    selected() {
      return this.listEnvois.filter((item) => {
        return item.selected;
      });
    },
    selectLimit() {
      if (this.selected.length > 9) return true;
      return false;
    },
    fieldsPdfs() {
      return [
        { name: "date", title: "Date Création", sortField: "date" },
        { name: "heure", title: "Heure Création", sortField: "heure" },
        { name: "__slot:download", title: "Télécharger" },
      ];
    },
    fields() {
      return [
        {
          name: "nom",
          title: this.$t("poissonnierTable.headings.enseigne"),
          sortField: "nom",
          width: "15%",
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "code_postal",
          width: "5%",
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville",
          width: "15%",
          dataClass: "adresse-smalltext",
        },
        {
          name: "contact_name",
          title: "Dirigeant",
          sortField: "contact_name",
          dataClass: "text-center",
          width: "15%",
          dataClass: "adresse-smalltext",
        },
        {
          name: "__slot:level",
          title: "Niveau de relance",
          sortField: "niveauTxt",
          dataClass: "text-center",
          width: "10%",
        },
        {
          name: "dateenvoi",
          title: "Date d'envoi",
          sortField: "dateenvoi",
          width: "10%",
        },
        {
          name: "__slot:envoiType",
          title: "Envoi",
          width: "8%",
        },

        {
          name: "__slot:actions",
          width: "10%",
        },
        {
          name: "__slot:selection",
          title: "Sélection",
          dataClass: "text-center",
          width: "10%",
        },
      ];
    },
    filteredData() {
      let filteredData = this.listEnvois;

      if (
        (!this.nomRe || this.nomRe.length < 1) &&
        (!this.cpRe || this.cpRe.length < 1) &&
        this.showinactive === "all"
      ) {
        return filteredData;
      }

      return filteredData.filter((item) => {
        let boolcond = true;
        if (
          this.showinactive === "adherent" &&
          moment(item.mdate_fin).isBefore(moment())
        ) {
          boolcond = false;
        }
        if (
          this.showinactive === "expired" &&
          !moment(item.mdate_fin).isBefore(moment())
        ) {
          boolcond = false;
        }

        if (this.nomRe && this.nomRe.length >= 1) {
          let nomCpre = deburr(this.nomRe).toLowerCase();
          boolcond =
            boolcond &&
            (deburr(item.nom).toLowerCase().includes(nomCpre) ||
              deburr(item.contact_name).toLowerCase().includes(nomCpre));
        }

        if (this.cpRe && this.cpRe.length >= 1) {
          let cpCpre = deburr(this.cpRe).toLowerCase();
          boolcond =
            boolcond &&
            (deburr(item.code_postal).toLowerCase().includes(cpCpre) ||
              deburr(item.ville).toLowerCase().includes(cpCpre));
        }

        return boolcond;
      });
    },
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
</style>
